import styled from 'styled-components';

export const SelectedLabelContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  .selected-labels {
    border-radius: 4px;
    border: 1px solid var(--neutrals-light-gray, #d7d7d7);
    background: var(--neutrals-white, #fff);
    padding: 6px 12px 4px 12px;
    // margin-bottom: 36px;
  }
`;
